__turbopack_context__.v({
  "label": "scene-animations-module__zrceda__label",
  "root": "scene-animations-module__zrceda__root",
  "tree": "scene-animations-module__zrceda__tree",
});
